"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentTeamStatus = void 0;
var TournamentTeamStatus;
(function (TournamentTeamStatus) {
    TournamentTeamStatus["Pending"] = "pending";
    TournamentTeamStatus["Standby"] = "standby";
    TournamentTeamStatus["Checkin"] = "checkin";
    TournamentTeamStatus["Ready"] = "ready";
    TournamentTeamStatus["Active"] = "active";
    TournamentTeamStatus["Inactive"] = "inactive";
    TournamentTeamStatus["Eliminated"] = "eliminated";
    TournamentTeamStatus["Disqualified"] = "disqualified";
})(TournamentTeamStatus = exports.TournamentTeamStatus || (exports.TournamentTeamStatus = {}));
//# sourceMappingURL=tournament-team-status.js.map